import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { getAuthToken } from '../helpers/authentication';
import { getIsAdmin } from '../helpers/Lookup';

const ProtectedRoute = ({ element: Element, ...rest }) => {
  const isLoggedIn = getAuthToken();
  const isAdmin = getIsAdmin();
  return (
    <Routes>
      <Route
        {...rest}
        element={isLoggedIn && isAdmin ? Element : <Navigate to="/login" replace />}
      />
    </Routes>
  );
};

export default ProtectedRoute;